import { Graph as RawGraph } from "@antv/graphlib";
export class Graph extends RawGraph {
}
//# sourceMappingURL=graph.js.map